"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFileUploadV2 = exports.serializeFileUploadV2 = void 0;
const serializeFileUploadV2 = (item) => {
    const files = item.data.files;
    if (Array.isArray(files) && files.some(({ identifier }) => identifier)) {
        const fileCount = files.filter(({ identifier }) => identifier).length;
        return `${fileCount} file${fileCount > 1 ? "s" : ""} uploaded`;
    }
    return "";
};
exports.serializeFileUploadV2 = serializeFileUploadV2;
const validateFileUploadV2 = (item) => {
    const files = item.data.files;
    if (!item.required || files?.some(({ identifier }) => identifier)) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must upload at least one file." } };
};
exports.validateFileUploadV2 = validateFileUploadV2;
//# sourceMappingURL=FileUploadV2.js.map